import { getRoles } from "./getRoles";

/**
 * Settings / master / configuration screens Sub-Admin never sees, even when
 * its role is granted the matching permission (docs/sub-admin/SUB_ADMIN_PLAN.md).
 * Used by the sidebar, the submenu tabs and the route guard so all three agree.
 */
export const SUB_ADMIN_HIDDEN_PATH_SUFFIXES = [
  // KRA, Performance Cycles and Appraisal Templates are NOT hidden: they show
  // for Sub-Admin when their permissions are granted (user decision 2026-11-03).
  "/expense/config",
  "/company-doc-master",
  "/360-questionnaire",
  "/360-reviews",
  "/lms/courses",
  "/lms/assessments",
  "/lms/learning-paths",
  "/lms/auto-assignment",
  "/lms/settings/data-retention",
  "/lms/settings/certificate-template",
  "/engage/awards",
  "/engage/badges",
  "/engage/moderation",
  "/engage/settings",
  "/permission-manager",
];

/** @returns {boolean} whether the logged-in user is a Sub-Admin */
export const isSubAdminUser = () => Boolean(getRoles(["Sub-Admin"]));

/**
 * Whether a path is a settings/master screen hidden from the current Sub-Admin.
 * Always false for every other role.
 * @param {string} path - route or sidebar path (query string ignored)
 * @returns {boolean}
 */
export const isHiddenForSubAdmin = (path = "") => {
  if (!isSubAdminUser()) return false;
  const cleanPath = String(path || "").split("?")[0];
  // The screen itself or any sub-route of it (e.g. /permission-manager/:id).
  return SUB_ADMIN_HIDDEN_PATH_SUFFIXES.some(
    (suffix) => cleanPath.endsWith(suffix) || cleanPath.includes(`${suffix}/`)
  );
};
